import { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import HeaderHomeScreen from "../../components/HeaderHomeScreen";
import "./index.css";
import "../../components/index.css";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { useIsFeatureEnabled, useUserTokenSelector } from "store/reducers";
import { sendOTPToUser } from "actions/auth";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";

const contentData = [
  {
    heading: "Relax",
    subheading: "using customized content",
    image: "https://ucarecdn.com/dfbda009-2f68-4994-b25d-d5f8015985f0/relaxImg.svg",
    bg: "#FCF2D8",
    width: "350px",
    height: "auto",
    marginLeft: "0px",
    width1: "290px",
    height1: "auto",
    marginLeft1: "0px",
  },
  {
    heading: "Personalized",
    subheading: "wellness solutions",
    image: "https://ucarecdn.com/044cc2c9-f7c1-4ec0-a11a-63c058c0dbd8/personalizedImg.svg",
    bg: "#E8EBFF",
    width: "280px",
    height: "auto",
    marginLeft: "100px",
    width1: "240px",
    height1: "auto",
    marginLeft1: "65px",
  },
  {
    heading: "Solutions",
    subheading: "from qualified experts",
    image: "https://ucarecdn.com/b36fe766-27ce-4d3a-b009-237dc2671e42/solutionsImg.svg",
    bg: "#E8FDF2",
    width: "350px",
    height: "auto",
    marginLeft: "0px",
    width1: "290px",
    height1: "auto",
    marginLeft1: "0px",
  },
];

const callingCodes = [
  { id: 1, name: "Afghanistan", code: "+93" },
  { id: 2, name: "Albania", code: "+355" },
  { id: 3, name: "Algeria", code: "+213" },
  { id: 4, name: "Andorra", code: "+376" },
  { id: 5, name: "Angola", code: "+244" },
  { id: 6, name: "Antigua and Barbuda", code: "+1-268" },
  { id: 7, name: "Argentina", code: "+54" },
  { id: 8, name: "Armenia", code: "+374" },
  { id: 9, name: "Australia", code: "+61" },
  { id: 10, name: "Austria", code: "+43" },
  { id: 11, name: "Azerbaijan", code: "+994" },
  { id: 12, name: "Bahamas", code: "+1-242" },
  { id: 13, name: "Bahrain", code: "+973" },
  { id: 14, name: "Bangladesh", code: "+880" },
  { id: 15, name: "Barbados", code: "+1-246" },
  { id: 16, name: "Belarus", code: "+375" },
  { id: 17, name: "Belgium", code: "+32" },
  { id: 18, name: "Belize", code: "+501" },
  { id: 19, name: "Benin", code: "+229" },
  { id: 20, name: "Bhutan", code: "+975" },
  { id: 21, name: "Bolivia", code: "+591" },
  { id: 22, name: "Bosnia and Herzegovina", code: "+387" },
  { id: 23, name: "Botswana", code: "+267" },
  { id: 24, name: "Brazil", code: "+55" },
  { id: 25, name: "Brunei Darussalam", code: "+673" },
  { id: 26, name: "Bulgaria", code: "+359" },
  { id: 27, name: "Burkina Faso", code: "+226" },
  { id: 28, name: "Burundi", code: "+257" },
  { id: 29, name: "Cambodia", code: "+855" },
  { id: 30, name: "Cameroon", code: "+237" },
  { id: 31, name: "Canada", code: "+1" },
  { id: 32, name: "Cape Verde", code: "+238" },
  { id: 33, name: "Cayman Islands", code: "+1-345" },
  { id: 34, name: "Central African Republic", code: "+236" },
  { id: 35, name: "Chad", code: "+235" },
  { id: 36, name: "Chile", code: "+56" },
  { id: 37, name: "China", code: "+86" },
  { id: 38, name: "Colombia", code: "+57" },
  { id: 39, name: "Comoros", code: "+269" },
  { id: 40, name: "Congo (Congo-Brazzaville)", code: "+242" },
  { id: 41, name: "Congo (Congo-Kinshasa)", code: "+243" },
  { id: 42, name: "Costa Rica", code: "+506" },
  { id: 43, name: "Croatia", code: "+385" },
  { id: 44, name: "Cuba", code: "+53" },
  { id: 45, name: "Cyprus", code: "+357" },
  { id: 46, name: "Czech Republic", code: "+420" },
  { id: 47, name: "Denmark", code: "+45" },
  { id: 48, name: "Djibouti", code: "+253" },
  { id: 49, name: "Dominica", code: "+1-767" },
  { id: 50, name: "Dominican Republic", code: "+1-809" },
  { id: 51, name: "Ecuador", code: "+593" },
  { id: 52, name: "Egypt", code: "+20" },
  { id: 53, name: "El Salvador", code: "+503" },
  { id: 54, name: "Equatorial Guinea", code: "+240" },
  { id: 55, name: "Eritrea", code: "+291" },
  { id: 56, name: "Estonia", code: "+372" },
  { id: 57, name: "Eswatini", code: "+268" },
  { id: 58, name: "Ethiopia", code: "+251" },
  { id: 59, name: "Fiji", code: "+679" },
  { id: 60, name: "Finland", code: "+358" },
  { id: 61, name: "France", code: "+33" },
  { id: 62, name: "Gabon", code: "+241" },
  { id: 63, name: "Gambia", code: "+220" },
  { id: 64, name: "Georgia", code: "+995" },
  { id: 65, name: "Germany", code: "+49" },
  { id: 66, name: "Ghana", code: "+233" },
  { id: 67, name: "Greece", code: "+30" },
  { id: 68, name: "Grenada", code: "+1-473" },
  { id: 69, name: "Guatemala", code: "+502" },
  { id: 70, name: "Guinea", code: "+224" },
  { id: 71, name: "Guinea-Bissau", code: "+245" },
  { id: 72, name: "Guyana", code: "+592" },
  { id: 73, name: "Haiti", code: "+509" },
  { id: 74, name: "Honduras", code: "+504" },
  { id: 75, name: "Hungary", code: "+36" },
  { id: 76, name: "Iceland", code: "+354" },
  { id: 77, name: "India", code: "+91" },
  { id: 78, name: "Indonesia", code: "+62" },
  { id: 79, name: "Iran", code: "+98" },
  { id: 80, name: "Iraq", code: "+964" },
  { id: 81, name: "Ireland", code: "+353" },
  { id: 82, name: "Israel", code: "+972" },
  { id: 83, name: "Italy", code: "+39" },
  { id: 84, name: "Jamaica", code: "+1-876" },
  { id: 85, name: "Japan", code: "+81" },
  { id: 86, name: "Jordan", code: "+962" },
  { id: 87, name: "Kazakhstan", code: "+7" },
  { id: 88, name: "Kenya", code: "+254" },
  { id: 89, name: "Kiribati", code: "+686" },
  { id: 90, name: "Korea (North)", code: "+850" },
  { id: 91, name: "Korea (South)", code: "+82" },
  { id: 92, name: "Kuwait", code: "+965" },
  { id: 93, name: "Kyrgyzstan", code: "+996" },
  { id: 94, name: "Laos", code: "+856" },
  { id: 95, name: "Latvia", code: "+371" },
  { id: 96, name: "Lebanon", code: "+961" },
  { id: 97, name: "Lesotho", code: "+266" },
  { id: 98, name: "Liberia", code: "+231" },
  { id: 99, name: "Libya", code: "+218" },
  { id: 100, name: "Liechtenstein", code: "+423" },
  { id: 101, name: "Lithuania", code: "+370" },
  { id: 102, name: "Luxembourg", code: "+352" },
  { id: 103, name: "Madagascar", code: "+261" },
  { id: 104, name: "Malawi", code: "+265" },
  { id: 105, name: "Malaysia", code: "+60" },
  { id: 106, name: "Maldives", code: "+960" },
  { id: 107, name: "Mali", code: "+223" },
  { id: 108, name: "Malta", code: "+356" },
  { id: 109, name: "Marshall Islands", code: "+692" },
  { id: 110, name: "Mauritania", code: "+222" },
  { id: 111, name: "Mauritius", code: "+230" },
  { id: 112, name: "Mexico", code: "+52" },
  { id: 113, name: "Micronesia", code: "+691" },
  { id: 114, name: "Moldova", code: "+373" },
  { id: 115, name: "Monaco", code: "+377" },
  { id: 116, name: "Mongolia", code: "+976" },
  { id: 117, name: "Montenegro", code: "+382" },
  { id: 118, name: "Morocco", code: "+212" },
  { id: 119, name: "Mozambique", code: "+258" },
  { id: 120, name: "Myanmar", code: "+95" },
  { id: 121, name: "Namibia", code: "+264" },
  { id: 122, name: "Nauru", code: "+674" },
  { id: 123, name: "Nepal", code: "+977" },
  { id: 124, name: "Netherlands", code: "+31" },
  { id: 125, name: "New Zealand", code: "+64" },
  { id: 126, name: "Nicaragua", code: "+505" },
  { id: 127, name: "Niger", code: "+227" },
  { id: 128, name: "Nigeria", code: "+234" },
  { id: 129, name: "North Macedonia", code: "+389" },
  { id: 130, name: "Norway", code: "+47" },
  { id: 131, name: "Oman", code: "+968" },
  { id: 132, name: "Pakistan", code: "+92" },
  { id: 133, name: "Palau", code: "+680" },
  { id: 134, name: "Panama", code: "+507" },
  { id: 135, name: "Papua New Guinea", code: "+675" },
  { id: 136, name: "Paraguay", code: "+595" },
  { id: 137, name: "Peru", code: "+51" },
  { id: 138, name: "Philippines", code: "+63" },
  { id: 139, name: "Poland", code: "+48" },
  { id: 140, name: "Portugal", code: "+351" },
  { id: 141, name: "Puerto Rico", code: "+1-787" },
  { id: 142, name: "Qatar", code: "+974" },
  { id: 143, name: "Romania", code: "+40" },
  { id: 144, name: "Russia", code: "+7" },
  { id: 145, name: "Rwanda", code: "+250" },
  { id: 146, name: "Saint Kitts and Nevis", code: "+1-869" },
  { id: 147, name: "Saint Lucia", code: "+1-758" },
  { id: 148, name: "Saint Vincent and the Grenadines", code: "+1-784" },
  { id: 149, name: "Samoa", code: "+685" },
  { id: 150, name: "San Marino", code: "+378" },
  { id: 151, name: "Sao Tome and Principe", code: "+239" },
  { id: 152, name: "Saudi Arabia", code: "+966" },
  { id: 153, name: "Senegal", code: "+221" },
  { id: 154, name: "Serbia", code: "+381" },
  { id: 155, name: "Seychelles", code: "+248" },
  { id: 156, name: "Sierra Leone", code: "+232" },
  { id: 157, name: "Singapore", code: "+65" },
  { id: 158, name: "Slovakia", code: "+421" },
  { id: 159, name: "Slovenia", code: "+386" },
  { id: 160, name: "Solomon Islands", code: "+677" },
  { id: 161, name: "Somalia", code: "+252" },
  { id: 162, name: "South Africa", code: "+27" },
  { id: 163, name: "South Sudan", code: "+211" },
  { id: 164, name: "Spain", code: "+34" },
  { id: 165, name: "Sri Lanka", code: "+94" },
  { id: 166, name: "Sudan", code: "+249" },
  { id: 167, name: "Suriname", code: "+597" },
  { id: 168, name: "Sweden", code: "+46" },
  { id: 169, name: "Switzerland", code: "+41" },
  { id: 170, name: "Syria", code: "+963" },
  { id: 171, name: "Taiwan", code: "+886" },
  { id: 172, name: "Tajikistan", code: "+992" },
  { id: 173, name: "Tanzania", code: "+255" },
  { id: 174, name: "Thailand", code: "+66" },
  { id: 175, name: "Togo", code: "+228" },
  { id: 176, name: "Tonga", code: "+676" },
  { id: 177, name: "Trinidad and Tobago", code: "+1-868" },
  { id: 178, name: "Tunisia", code: "+216" },
  { id: 179, name: "Turkey", code: "+90" },
  { id: 180, name: "Turkmenistan", code: "+993" },
  { id: 181, name: "Tuvalu", code: "+688" },
  { id: 182, name: "Uganda", code: "+256" },
  { id: 183, name: "Ukraine", code: "+380" },
  { id: 184, name: "United Arab Emirates", code: "+971" },
  { id: 185, name: "United Kingdom", code: "+44" },
  { id: 186, name: "United States", code: "+1" },
  { id: 187, name: "Uruguay", code: "+598" },
  { id: 188, name: "Uzbekistan", code: "+998" },
  { id: 189, name: "Vanuatu", code: "+678" },
  { id: 190, name: "Vatican City", code: "+39" },
  { id: 191, name: "Venezuela", code: "+58" },
  { id: 192, name: "Vietnam", code: "+84" },
  { id: 193, name: "Yemen", code: "+967" },
  { id: 194, name: "Zambia", code: "+260" },
  { id: 195, name: "Zimbabwe", code: "+263" },
];

const TherapistLogin = () => {
  const [loggedOutMessage, setLoggedOutMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [number, setNumber] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const nextRef = useRef();
  const referer = location.state?.referer;
  const userToken = useUserTokenSelector();
  const history = useHistory();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % contentData.length);
    }, 5000);

    if (userToken) {
      if (referer) {
        history.push(referer);
      } else {
        history.push("/dashboard");
      }
    }
    const queryParams = new URLSearchParams(location.search);
    const error = queryParams.get("error");
    if (error === "googleSignup") {
      setLoggedOutMessage("You can't use corporate sign up. Please sign up with Mobile no. 📱");
      setSeverity("error");
      setOpen(true);
      history.replace({ search: "" });
    } else if (error === "accountSuspended") {
      setLoggedOutMessage("GoodLives is all New! Please login using your phone number to restore the account.");
      setSeverity("error");
      setOpen(true);
      history.replace({ search: "" });
    }

    return () => clearInterval(interval);
  }, []);

  const sendOtp = async () => {
    try {
      if (!/^\d{9,11}$/.test(number)) {
        setLoggedOutMessage("Please enter a valid mobile number");
        setSeverity("error");
        setOpen(true);
        return;
      } else {
        dispatch(startLoading());
        const response = await sendOTPToUser({
          phone: number,
          countryCode: countryCode,
          purpose: 1,
        });
        if (response.data.otpSent) {
          dispatch(stopLoading());
          history.push({
            pathname: "/otpVerification",
            state: { number: number, countryCode: countryCode },
          });
        }
      }
      setOtpSent(true);
    } catch (error) {
      setLoggedOutMessage(error.response?.data?.message || error.response?.data?.error || "An unknown error occurred");
      setOpen(true);
      console.error("error", error.response?.data?.message || error.response?.data?.error || "An unknown error occurred");
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleNumberKeypress = (e) => {
    if (e.key === "Enter") {
      sendOtp();
    }
  };

  const handleClose = (reason) => {
    if (reason === "clickaway") {
      setOpen(false);
    }
    setOpen(false);
    setLoggedOutMessage("");
  };

  const handleSelectChange = (code) => {
    setCountryCode(code);
    setShowDropdown(false);
  };

  return (
    <div>
      <HeaderHomeScreen />
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity || "success"} sx={{ width: "100%" }}>
          {loggedOutMessage}
        </Alert>
      </Snackbar>
      <div className="num-screen-main-container" style={{ backgroundColor: contentData[index].bg }}>
        {isMobile ? (
          <div>
            <div className="mobileScreen-num-box-Image" style={{ backgroundColor: contentData[index].bg }}>
              <h2>{contentData[index].heading}</h2>
              <p>{contentData[index].subheading}</p>
              <img
                src={contentData[index].image}
                alt={contentData[index].heading}
                style={{
                  width: contentData[index].width1,
                  height: contentData[index].height1,
                  marginLeft: contentData[index].marginLeft1,
                }}
              />
            </div>
            <div className="mobileScreen-num-box">
              <div style={{ padding: "18px 4px", borderRadius: "12px", margin: "26px 0" }}>
              <a
                href={`${
                  process.env.REACT_APP_SERVER_URI
                }/api/therapist/auth/google?referer=${referer || "none"}&signin=true`}
                style={{ textDecoration: "none", color: "black", width: "90%", alignSelf: "center" }}
              >
                <div className="noaccountpara" style={{ border: "1px solid #65ae8993"}}>
                  Sign In with {/* <Link to={{ pathname: "signup", state: { referer: referer } }}> */}
                  <img
                    src="https://ucarecdn.com/7a98107d-8029-4998-a896-207b1a316f11/googlelogo.png"
                    style={{ height: "20px", width: "20px" }}
                  />
                  {/* </Link> */}
                </div>
              </a>
                </div>
            </div>
          </div>
        ) : (
          <>
            <div className="num-box">
              <div style={{  padding: "32px 12px", borderRadius: "12px" }}>
                <p className="num-box-heading">Welcome to Goodlives</p>
              <a
                href={`${
                  process.env.REACT_APP_SERVER_URI
                }/api/therapist/auth/google?referer=${referer || "none"}&signin=true`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <div className="noaccountpara" style={{ border: "1px solid #65ae8993"}}>
                  Sign In with {/* <Link to={{ pathname: "signup", state: { referer: referer } }}> */}
                  <img
                    src="https://ucarecdn.com/7a98107d-8029-4998-a896-207b1a316f11/googlelogo.png"
                    style={{ height: "20px", width: "20px" }}
                  />
                  {/* </Link> */}
                </div>
              </a>
                </div>
              
            </div>
            <div className="num-box-Image" style={{ backgroundColor: contentData[index].bg }}>
              <h2>{contentData[index].heading}</h2>
              <p>{contentData[index].subheading}</p>
              <img
                src={contentData[index].image}
                alt={contentData[index].heading}
                style={{
                  width: contentData[index].width,
                  height: contentData[index].height,
                  marginLeft: contentData[index].marginLeft,
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TherapistLogin;
